import { Fragment } from "react";

// Thai short month, Gregorian year (no Buddhist offset).
// e.g. "10 ก.พ. 2026"
const TH = "th-TH-u-ca-gregory";

// One formatter for the whole page. `new Intl.DateTimeFormat` is one of the
// more expensive constructors in the platform (locale data lookup + pattern
// compilation); the homepage renders ~40 dates, so building one per render was
// tens of milliseconds of hydration on a throttled CPU for identical options.
// Created lazily so a runtime without the Thai locale still fails at the call
// site rather than at module load.
let formatter: Intl.DateTimeFormat | null = null;
const getFormatter = () =>
  (formatter ??= new Intl.DateTimeFormat(TH, {
    day: "numeric",
    month: "short",
    year: "numeric",
    // Pin the zone so SSR (UTC on Workers) and the browser render the same day.
    timeZone: "Asia/Bangkok",
  }));

export const formatThaiDate = (date: string): string => {
  if (!date) return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  return getFormatter().format(d);
};

// Broadcast clock, 24-hour, pinned to Bangkok for the same reason as the date
// ("16:33"). The list cards (ArticleCard) print it; the home page and the
// article header keep their own copies of the same formatter.
let timeFormatter: Intl.DateTimeFormat | null = null;
export const formatBangkokTime = (date: string): string => {
  if (!date) return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  timeFormatter ??= new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Asia/Bangkok",
  });
  return timeFormatter.format(d);
};

const DateFormat = (props: any) => <Fragment>{formatThaiDate(props.dateTime)}</Fragment>;

export default DateFormat;
